import { SonoraTopicEntity } from 'owa-editor-sonora-types';
import { ITopicEntity } from '@1js/cortex-topics-types';
import { TOPIC_ENTITY_TYPE } from 'owa-topic-common';
import { TopicManualAnnotation } from 'owa-topic-common/lib/lazyFunctions';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { insertEntity } from 'roosterjs-editor-api';
import type { IEditor } from 'roosterjs-editor-types';

export const getPrimaryTextForSonoraResultsVivaTopicEntityItems = (
    sonoraItem: SonoraTopicEntity
): string => {
    return sonoraItem.displayName;
};

export const getSecondaryTextForSonoraResultsVivaTopicEntityItems = (
    sonoraItem: SonoraTopicEntity
): string => {
    return sonoraItem.definition;
};

export const getTooltipStringForSonoraResultsVivaTopicEntityItems = (
    sonoraItem: SonoraTopicEntity
): string => {
    return sonoraItem.definition;
};

export const insertVivaTopicEntitySuggestionsIntoComposeEditor = (
    sonoraItem: SonoraTopicEntity,
    insertNodeCallback: (nodeToInsert: HTMLElement) => void,
    editor: IEditor | undefined
): void => {
    if (!editor) {
        return;
    }

    const topicElement = editor!.getDocument().createElement('span');
    const topicEntity = {
        DisplayName: sonoraItem.displayName,
        Id: sonoraItem.id,
        Url: sonoraItem.url,
    } as ITopicEntity;

    ReactDOM.render(
        React.createElement(TopicManualAnnotation, {
            topic: topicEntity,
            source: 'Sonora',
        }),
        topicElement
    );

    // This is needed to avoid having both the text and the entity.
    // See TopicPickerDataProvider.tsx.
    insertNodeCallback(topicElement);
    insertEntity(
        editor!,
        TOPIC_ENTITY_TYPE,
        topicElement,
        false /* isBlock */,
        true /* isReadonly */
    );
};
